import React from "react";

const FilmGrain = () => <div className="film-grain-fixed" aria-hidden="true" />;

export default FilmGrain;
